import React from "react";
import Markdown from "~/components/Markdown";
import Collapsable from "~/components/Collapsable";
import { Badge, Box, Icon, Link, Picture, Text } from "~/components-shared";
import { CollapsableTypeEnum } from "~/types/enums";
import styled from "styled-components";
import FootprintActions from "~/components/FootprintActions";
import moment from "moment";
const Underline = styled.span`
  text-decoration: underline;
`;
const resolveCustomFieldValue = field => {
  switch (field.schema.type) {
    case "array":
      {
        switch (field.schema.items) {
          case "user":
            return field.value?.map(item => item.displayName).join(", ") || "-";
          case "option":
            return field.value?.map(item => item.value).join(", ") || "-";
          case "json":
            return field.value?.map(item => item.name).join(", ") || "-";
          default:
            return field.value ? JSON.stringify(field.value) : "-";
        }
      }
    case "date":
      return field.value ? moment(field.value).format("MMM D, YYYY") : "-";
    case "datetime":
      return field.value ? moment(field.value).format("ddd, MMM D hh:mma") : "-";
    case "option-with-child":
    case "option":
      return field.value?.value || "-";
    case "string":
    case "number":
      return field.value || "-";
    case "any":
    default:
      return field.value ? JSON.stringify(field.value) : "-";
  }
};
const TopicFootprintContentJira = _ref => {
  let {
    footprint,
    hideDetails = false,
    hideMessage = false
  } = _ref;
  const {
    actions,
    data
  } = footprint;
  const {
    issueUrl,
    issueKey,
    assigneeName,
    assigneeAvatar,
    assigneeUrl,
    issueLabels,
    issueTitle,
    issueStatusName,
    issueTypeName,
    issueDescription,
    parentId,
    parentName,
    parentTypeName,
    customFields,
    comment
  } = data;
  return /*#__PURE__*/React.createElement(React.Fragment, null, !hideDetails && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Text, {
    display: "block",
    color: "textSecondary",
    weight: "semiBold"
  }, /*#__PURE__*/React.createElement(FootprintActions, {
    actions: actions
  }), " a Jira issue", " ", /*#__PURE__*/React.createElement(Link, {
    href: issueUrl,
    underline: true
  }, issueKey), " ", assigneeName && /*#__PURE__*/React.createElement(Text, null, "assigned to", " ", /*#__PURE__*/React.createElement(Picture, {
    src: assigneeAvatar,
    width: "1.4rem",
    height: "1.4rem",
    display: "inline-block",
    border: "circled",
    s: {
      mb: -1
    }
  }), " ", /*#__PURE__*/React.createElement(Link, {
    href: assigneeUrl,
    underline: true
  }, assigneeName), " "), !!issueLabels?.length && /*#__PURE__*/React.createElement(Text, null, "labelled with ", /*#__PURE__*/React.createElement(Underline, null, issueLabels.join(", ")))), /*#__PURE__*/React.createElement(Text, {
    weight: "semiBold",
    fontSize: 4.5,
    lineHeight: 6.5,
    display: "block",
    s: {
      my: 1
    }
  }, !!parentId && /*#__PURE__*/React.createElement(React.Fragment, null, parentName, /*#__PURE__*/React.createElement(Badge, {
    color: "translucent",
    display: "inline",
    s: {
      py: 0.5,
      mx: 2,
      mt: -0.5
    }
  }, parentTypeName), /*#__PURE__*/React.createElement(Icon, {
    src: "arrow",
    s: {
      mt: -0.5,
      mr: 2
    }
  })), issueTitle, /*#__PURE__*/React.createElement(Badge, {
    color: "translucent",
    display: "inline",
    s: {
      py: 0.5,
      mx: 2,
      mt: -0.5
    }
  }, issueTypeName, " | ", issueStatusName))), !hideMessage && /*#__PURE__*/React.createElement(React.Fragment, null, issueDescription && /*#__PURE__*/React.createElement(Collapsable, {
    maxHeight: 0,
    type: CollapsableTypeEnum.BUTTON,
    s: {
      mb: 3
    },
    collapsedText: "View task description",
    expandedText: "Hide task description"
  }, /*#__PURE__*/React.createElement(Markdown, {
    text: issueDescription,
    fontSize: 4,
    lineHeight: 6,
    display: "block"
  })), customFields?.length ? /*#__PURE__*/React.createElement(Collapsable, {
    maxHeight: 0,
    type: CollapsableTypeEnum.BUTTON,
    s: {
      mb: 3
    },
    collapsedText: "View custom fields",
    expandedText: "Hide custom fields"
  }, /*#__PURE__*/React.createElement(Box, {
    gap: 0.5
  }, customFields.map(field => /*#__PURE__*/React.createElement(Text, {
    color: "textSecondary",
    s: {
      mr: 5
    }
  }, /*#__PURE__*/React.createElement(Text, {
    weight: "semiBold"
  }, field.name), ": ", resolveCustomFieldValue(field))))) : undefined, comment && /*#__PURE__*/React.createElement(Collapsable, null, /*#__PURE__*/React.createElement(Markdown, {
    text: comment,
    fontSize: 4,
    lineHeight: 6,
    display: "block"
  }))));
};
export default TopicFootprintContentJira;